import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList } from '@/api/PMS/estateManagement/notice/noticeType';
import { fetchCreate, fetchUpdate, fetchDetail } from '@/api/PMS/estateManagement/notice/issueNotice';
import Tinymce from '@/components/Tinymce';
export default {
  components: {
    Tinymce: Tinymce
  },
  props: ['keyValue', 'showDialog', 'isDetail'],
  data: function data() {
    return {
      rules: {
        title: [{
          required: true,
          message: '请输入通知标题',
          trigger: 'blur'
        }, {
          min: 1,
          max: 50,
          message: '长度在 1 到 50 个字符',
          trigger: 'change'
        }],
        content: [{
          required: true,
          message: '请输入通知内容',
          trigger: 'change'
        }, {
          min: 1,
          max: 30000,
          message: '长度在 1 到 30000 个字符',
          trigger: 'change'
        }],
        activeDates: [{
          required: true,
          message: '请选择有效期限',
          trigger: 'change'
        }],
        noticeTypeId: [{
          required: true,
          message: '请选择通知类型',
          trigger: 'change'
        }],
        isReceipt: [{
          required: true,
          message: '请选择回执类型',
          trigger: 'change'
        }],
        receiverObjectType: [{
          required: true,
          message: '请选择通知对象',
          trigger: 'change'
        }]
      },
      propstree: {
        label: 'deptName',
        value: 'deptId',
        children: 'childDept'
      },
      readonly: 1,
      files: [],
      listObj: [],
      toolbar: [''],
      typeOption: [],
      oldImgList: [],
      removeList: [],
      uploadUrl: '',
      downloadUrl: '',
      addList: [],
      uploadList: [],
      dialogImageUrl: '',
      picUrl: '',
      imageUrl: '',
      dialogVisible: false,
      fileList: [],
      childData: {}
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    this.uploadUrl = process.env.VUE_APP_UPLOAD;
    this.downloadUrl = process.env.VUE_APP_DOWNLOAD;
    this.init();
    this.getTypeOption();
  },
  methods: {
    getReceiverObjectName: function getReceiverObjectName() {
      var res = '';

      if (this.childData.receiverObjectType === 0) {
        res = '全体成员';
      } else if (this.childData.receiverObjectType === 1) {
        res = '全体物业';
      } else if (this.childData.receiverObjectType === 2) {
        res = '全体业主';
      } else if (this.childData.receiverObjectType === 3) {
        res = '全体租户';
      }

      return res;
    },
    getTypeOption: function getTypeOption() {
      var _this = this;

      fetchList({}).then(function (res) {
        if (res.data.code === 200) {
          _this.typeOption = res.data.data;
        }
      });
    },
    init: function init() {
      var _this2 = this;

      this.delFileList = [];
      this.fileList = [];
      this.files = [];
      this.addList = [];
      this.removeList = [];
      this.$nextTick(function () {
        _this2.$refs['dataForm'].clearValidate();
      });

      if (this.keyValue > 0) {
        var queryData = {
          id: this.keyValue
        };
        fetchDetail(queryData).then(function (response) {
          _this2.childData = response.data.data;

          _this2.$set(_this2.childData, 'activeDates', [_this2.childData.beginTime, _this2.childData.endTime]);

          _this2.childData.noticeFileListVo.forEach(function (item) {
            item.name = item.fileName;
            item.url = item.filePath;
          });

          _this2.fileList = _this2.childData.noticeFileListVo;
          _this2.oldImgList = JSON.parse(JSON.stringify(_this2.childData.noticeFileListVo));
          _this2.files = _this2.childData.noticeFileListVo;
          var that = _this2;
          setTimeout(function () {
            that.$refs['editor'].setContent(that.childData.content);
            that.$refs['viewer'].setContent(that.childData.content);
          }, 100);
        });
      } else {
        this.childData = {};
        var that = this;
        setTimeout(function () {
          that.$refs['editor'].setContent('');
          that.$refs['viewer'].setContent('');
        }, 100);
      }
    },
    changeLocationValue: function changeLocationValue(val) {
      var obj = {};
      obj = this.locations.find(function (item) {
        return item.id === val;
      });
      var getName = '';
      getName = obj.locationName;
      console.log(getName);
    },
    handCreate: function handCreate() {
      var _this3 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          if (!_this3.childData.content) {
            _this3.Alert({
              alertType: 'valid',
              message: '通知内容不能为空'
            });

            return;
          }

          _this3.childData.beginTime = _this3.childData.activeDates[0];
          _this3.childData.endTime = _this3.childData.activeDates[1];
          _this3.childData.publishStatus = 0;
          _this3.childData.isReceipt = 0;
          _this3.childData.receiverObjectType = 0;
          delete _this3.childData.activeDates;

          if (_this3.keyValue > 0) {
            _this3.childData.changeNoticeFileVos = _this3.addList;
            _this3.childData.deleteNoticeFileVo = {
              ids: _this3.removeList
            };
            fetchUpdate(_this3.childData).then(function () {
              _this3.$emit('handCancle', true);

              _this3.Alert({
                alertType: 'update'
              });
            });
          } else {
            _this3.childData.changeNoticeFileVos = _this3.fileList;
            fetchCreate(_this3.childData).then(function () {
              _this3.$emit('handCancle', true);

              _this3.Alert({
                alertType: 'add'
              });
            });
          }
        } else {
          _this3.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', 'repairAdd');
    },
    // 上传图片成功时获取服务器图片URL
    handleSuccess: function handleSuccess(response, file) {
      this.addList.push({
        id: this.keyValue,
        filePath: file.response.data[0].fileId,
        fileName: response.data[0].fileName,
        fileExt: this.judgeFileType(file.raw.type)
      });
      this.fileList.push({
        filePath: file.response.data[0].fileId,
        fileName: response.data[0].fileName,
        name: response.data[0].fileName,
        fileExt: this.judgeFileType(file.raw.type)
      });
    },
    handleError: function handleError(err, file) {
      var res = JSON.parse(err.message);
      this.$message({
        message: res.message,
        type: 'error'
      });
    },
    handleExceed: function handleExceed() {},
    handlePreview: function handlePreview(file) {
      console.log('file', file);

      if (file.response) {
        // 当还未保存到业务逻辑中时的预览图片
        if (file.name === 'image/png' || file.name === 'image/jpeg' || file.name === 'image/jpg') {
          // 当附件是图片的时候在线打开
          this.dialogVisible = true;
          this.dialogImageUrl = this.downloadUrl + file.response.data[0].fileId;
        } else {
          // 当附件是文件的时候在线下载
          this.dialogImageUrl = this.downloadUrl + file.response.data[0].fileId;
          this.handleDownload(this.dialogImageUrl, file.name);
        }
      } else {
        // 当已保存到业务逻辑中时的预览图片
        if (file.filePath !== undefined) {
          file.url = file.filePath;
        }

        if (file.fileName.includes('png') || file.fileName.includes('jpg') || file.fileName.includes('jpeg')) {
          // 当附件是图片的时候在线打开
          this.dialogVisible = true;
          this.dialogImageUrl = this.downloadUrl + file.url;
        } else {
          // 当附件是文件的时候在线下载
          this.dialogImageUrl = this.downloadUrl + file.url;
          this.handleDownload(this.dialogImageUrl, file.name);
          console.log(this.dialogImageUrl + '   ' + file.name);
        }
      }
    },
    // 移除图片之前做的操作
    beforeRemove: function beforeRemove(file, fileList) {// return this.$confirm(`确定移除 ${ file.name }？`)
    },
    beforeUpload: function beforeUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 10;

      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 10MB!',
          type: 'error'
        });
        return false;
      }
    },
    // 移除图片
    handleRemove: function handleRemove(file, fileList) {
      var _this4 = this;

      var currentUrl = 0; // 获取当前删除文件的url

      var currentFileName = ''; // 获取当前删除文件的文件名

      var currentFileType = ''; // 获取当前删除文件的文件类型

      if (file.response !== undefined) {
        // 文件是新增加的
        currentUrl = file.response.data[0].fileId;
        currentFileName = file.response.data[0].fileName;
        currentFileType = file.raw.type;
      } else {
        // 文件是旧数据
        currentUrl = file.url;
        currentFileName = file.name;
        currentFileType = file.type;
      }

      this.fileList.forEach(function (item, index) {
        if (currentUrl === item.url) {
          _this4.fileList.splice(index, 1);

          return;
        }
      });
      this.oldImgList.forEach(function (col, n) {
        console.log('col', col);

        if (currentUrl === col.filePath) {
          _this4.removeList.push(col.fileId);

          return;
        }
      });
      this.addList.forEach(function (item, index) {
        if (item.filePath === currentUrl) {
          _this4.addList.splice(index, 1);
        }
      });
    },
    // 下载文件
    handleDownload: function handleDownload(url, name) {
      console.log('下载文件url=', url);
      var link = document.createElement('a');
      link.style.display = 'none';
      link.href = url;
      link.setAttribute('download', name);
      document.body.appendChild(link);
      link.click();
    },
    // 判断上传的文件类型，方便数据库保存
    judgeFileType: function judgeFileType(str) {
      if (str === 'image/png' || str === 'image/jpeg' || str === 'image/jpg') {
        return 2;
      } else {
        return 1;
      }
    }
  }
};